import React, { useState, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Header from '../Header';

const LayoutRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%',
  backgroundColor: theme.palette.background.default,
}));

const LayoutContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 64,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 0,
  },
  backgroundColor: theme.palette.background.default,
}));

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isSidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <LayoutRoot>
      <Header onSidebarOpen={() => setSidebarOpen(true)} />
      <Sidebar
        onClose={() => setSidebarOpen(false)}
        open={isSidebarOpen}
        variant={isMobile ? 'temporary' : 'permanent'}
      />
      <LayoutContent>
        <Box 
          sx={{ 
            flex: '1 1 auto',
            p: { xs: 2, sm: 3 },
            width: '100%',
          }}
        >
          <Outlet />
        </Box>
      </LayoutContent>
    </LayoutRoot>
  );
};

export default Layout; 